import React, { useEffect, useState } from 'react';

//Header Data
import { setGalleryPageNumber } from '../../store/DslStore';

import { PaginationSwitch } from '../../components/Contest/GalleryNavigation/GalleryNavigation';
import { Contest, GalleryDesign, User } from '../../global';

import axiosHelper from '../../helpers/axiosHelper';
import GalleryNavigationWLF from '../../components/Contest/GalleryNavigation/GalleryNavigationWLF';
import useSWR from 'swr';
import DesignCard from '../../components/Design/DesignCard/DesignCard';
import DesignRow from '../../components/Design/DesignCard/DesignRow';
import DesignComponent from '../../components/Design/DesignComponent/DesignComponent';
import LogoAnimation from '../../components/LogoAnimation/LogoAnimation';
import { clearPortfolioNames } from '../../store/DesallStore';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faUserPlus } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { useBanner } from '../../context/BannerContext';
import { briefUrlForContest } from '../../helpers/navigationUtils';

interface Props {
  contest: Contest;
  designName?: string;
  loggedUser: User | null;
  loginCallback?: () => void;
}

const GalleryWLF: React.FC<Props> = ({ contest, designName, loggedUser, loginCallback }) => {
  const [numberOfPages, setNumberOfPages] = useState(1);
  const [layoutGallery, setLayoutGallery] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const [designs, setDesigns] = useState<GalleryDesign[]>([]);
  const [visibleDesign, setVisibleDesign] = useState<GalleryDesign[]>([]);
  const { data, error, isLoading } = useSWR('id|' + contest.id, axiosHelper.galleryFetcher);
  const [designNames, setDesignNames] = useState<string[]>([]);
  const navigate = useNavigate();
  const { createAndAddBannerMessage } = useBanner();
  const [shouldRedirect, setShouldRedirect] = useState(false);

  useEffect(() => {
    if (shouldRedirect) {
      navigate(briefUrlForContest(contest));
    }
  }, [shouldRedirect, navigate]);

  useEffect(() => {
    if (contest) {
      if (contest.hideGalleryTab || contest.isPrivate || contest.needsAccessCode || contest.needsNDA) {
        if (loggedUser?.userType === 'G') {
          setShouldRedirect(false);
        } else if (loggedUser?.userType === 'C' && loggedUser?.username === contest?.username) {
          setShouldRedirect(false);
        } else {
          createAndAddBannerMessage('Access denied', 'error', 'access-denied' + contest.id);

          setShouldRedirect(true);
        }
      }
    }
  }, [contest, loggedUser]);

  useEffect(() => {
    if (data) {
      setDesigns(data);
    }
  }, [data]);

  useEffect(() => {
    console.log(designs);
    setNumberOfPages(Math.ceil(designs.length / 20));
  }, [designs]);

  useEffect(() => {
    const arraysfill = () => {
      let chunkSize = 20;
      let startchunk = (pageNumber - 1) * chunkSize;
      let tempArray: GalleryDesign[] = [];
      let chunk: GalleryDesign[] = [];
      let names = [];
      for (let i = 0; i < designs.length; i++) {
        names.push(designs[i].nameForURL);
      }
      clearPortfolioNames();
      setDesignNames(names);
      for (let i = 0; i < designs.length; i += chunkSize) {
        chunk = designs.slice(startchunk, startchunk + chunkSize);
        // console.log('chunk');
        // console.log(chunk);
      }
      for (let i = 0; i < chunkSize; i++) {
        // console.log(chunk[i]);
        // console.log(chunk[i] === undefined);
        if (chunk[i] !== undefined) {
          tempArray.push(chunk[i]);
        } else {
          break;
        }
      }
      // console.log("array1:  ");
      console.log(tempArray);

      setVisibleDesign(tempArray);
    };
    arraysfill();
    // contest?.contestType === 'Co-creation' && arraysfillCoCreation();
    console.log(designs);
  }, [designs, pageNumber]);
  if (designName) {
    return <DesignComponent designName={designName} contest={contest} loggedUser={loggedUser} designNames={designNames} />;
  }
  return (
    <div className="bg-light-gray">
      <main className={`container pt-5 mb-5 px-sm-0 overflow-hidden`}>
        {true ? (
          <>
            {isLoading ? (
              <LogoAnimation />
            ) : (
              <>
                <div className="row ">
                  <GalleryNavigationWLF designs={designs} contest={contest} numberOfPages={numberOfPages} onChangeLayout={setLayoutGallery} />
                </div>
                <div className="row me-2 ">
                  {layoutGallery === 1
                    ? visibleDesign.map((aPublicDesign: GalleryDesign, index: number) => (
                        <div className=" col-12 col-md-6 col-lg-4 col-xl-3">
                          <DesignCard key={index} contest={contest} design={aPublicDesign} />
                        </div>
                      ))
                    : ''}
                </div>
                <div className="row mt-3 px-sm-1">
                  <div className="px-sm-3">
                    {layoutGallery === 2
                      ? visibleDesign.map((aPublicDesign: GalleryDesign, index: number) => <DesignRow contest={contest} design={aPublicDesign} key={index} />)
                      : ''}
                  </div>
                </div>
                <div className="row px-2">
                  <div className="col-12 px-4 d-flex justify-content-sm-start justify-content-md-end ">
                    {visibleDesign.length > 0 ? <PaginationSwitch onChangePage={setGalleryPageNumber} /> : ''}
                  </div>
                </div>
              </>
            )}
          </>
        ) : (
          <div className="row justify-content-center  ">
            <div className="col-10 col-md-3 mb-10">
              <button className="btn-success big full mb-4 rounded " style={{ height: '45px' }} onClick={loginCallback}>
                <div className="btn-icon ">
                  <FontAwesomeIcon icon={faUserPlus as IconProp} style={{ fontSize: '2.5rem' }} className="text color-light" />
                </div>
                <div>Join desall </div>
              </button>
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

export default GalleryWLF;
